(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snk-footer"]) return;
  try {
    
  console.log('snk 1')

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snk-hero"] && !window.DesignMode) return;
  try {
    
  // Initialize Lottie animation
  console.log('snk-lottie2');
  const animationContainer = document.getElementById('lottie-container');
  const animationPath = '/cdn/shop/t/1/assets/snk-logo-white2.json';
  const animation = lottie.loadAnimation({
    container: animationContainer,
    renderer: 'svg', // or 'canvas'
    loop: false,
    autoplay: true,
    path: animationPath,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["snk-story"] && !window.DesignMode) return;
  try {
    

function adjustTextWidth() {
  const textContainers = document.querySelectorAll('.dynamic-text');

  textContainers.forEach(textContainer => {
    const textSpan = textContainer.querySelector('span');

    // Reset font size to its initial state with a small delay
    textSpan.style.fontSize = 'initial';
    setTimeout(() => {
      const containerWidth = textContainer.offsetWidth;
      const textWidth = textSpan.offsetWidth;

      const scaleFactor = containerWidth / textWidth * .9;
      const fontSize = scaleFactor * 100;
    
      textSpan.style.fontSize = `${fontSize}%`;

      console.log({ containerWidth, textWidth, scaleFactor, fontSize });
    }, 10); // Adjust the delay as needed
  });
}


  // Call the function initially and whenever the window is resized
  adjustTextWidth();
  window.addEventListener('resize', adjustTextWidth);

   // {
   //    "type": "textarea",
   //    "label": "Hero Title",
   //    "id": "snk_hero_title",
   //    "default": "Default Hero title"
   //  },

  } catch(e) { console.error(e); }
})();
      })();
